'use client';

import { useEffect } from 'react';

/**
 * Registers the pass-through service worker (public/sw.js) so the app is
 * installable as a PWA / Trusted Web Activity. Renders nothing.
 *
 * The worker itself caches nothing (see public/sw.js) — this exists purely to
 * satisfy the installability requirement and to enable the Web Share Target
 * declared in the manifest. Registration failures are non-fatal and logged.
 */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    const register = () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.error('[sw] registration failed:', err);
      });
    };
    // Defer to the load event so registration never competes with first paint.
    if (document.readyState === 'complete') {
      register();
    } else {
      window.addEventListener('load', register, { once: true });
      return () => window.removeEventListener('load', register);
    }
  }, []);

  return null;
}
